import styled from '@emotion/styled'

/* Lumen caps a `scrollable` table at 10 rows. Taking the table out of flow stops it from contributing
   its row height to ModuleContent, so it fills the space left and scrolls inside it instead. */
export const ProfitAndLossTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: var(--lumen-padding-24);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-x: auto;
  overflow-y: hidden;

  > div {
    min-height: 0;
    max-height: 100%;
  }
`
